import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export class ExcelExporter {
  static exportToExcel(data: any[][], filename: string = 'grade_sheet.xlsx') {
    try {
      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Convert matrix data back to Excel format
      const worksheet = XLSX.utils.aoa_to_sheet([]);

      // Set the range
      const maxRow = data.length;
      const maxCol = data[0]?.length || 0;
      worksheet['!ref'] = XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: maxRow - 1, c: maxCol - 1 }
      });

      // Fill the worksheet with data
      data.forEach((row, rowIndex) => {
        row.forEach((cell, colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });

          if (cell.isFormula && cell.formula) {
            // Restore formula
            worksheet[cellAddress] = {
              f: cell.formula,
              v: cell.value,
              t: typeof cell.value === 'number' ? 'n' : 's'
            };
          } else {
            // Regular value
            worksheet[cellAddress] = {
              v: cell.value,
              t: typeof cell.value === 'number' ? 'n' : 's'
            };
          }
        });
      });

      // Add the worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Grade Sheet');

      // Generate Excel file without cellFormula option
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      // Create blob and save
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      saveAs(blob, filename);

      console.log('Excel file exported successfully');
      return true;
    } catch (error) {
      console.error('Error exporting Excel file:', error);
      throw new Error('Failed to export Excel file');
    }
  }

  static exportGradeSheetTemplate() {
    const templateData = [
    ['Student Name', 'Student ID', 'Assignment 1', 'Assignment 2', 'Midterm', 'Final', 'Total', 'Grade'],
    ['John Doe', 'ST001', 85, 90, 88, 92, '=SUM(C2:F2)', '=IF(G2>=90,"A",IF(G2>=80,"B",IF(G2>=70,"C","F")))'],
    ['Jane Smith', 'ST002', 78, 85, 80, 88, '=SUM(C3:F3)', '=IF(G3>=90,"A",IF(G3>=80,"B",IF(G3>=70,"C","F")))'],
    ['Bob Johnson', 'ST003', 92, 88, 90, 95, '=SUM(C4:F4)', '=IF(G4>=90,"A",IF(G4>=80,"B",IF(G4>=70,"C","F")))']];


    // Convert to the expected format
    const formattedData = templateData.map((row) =>
    row.map((cell) => ({
      value: cell,
      formula: typeof cell === 'string' && cell.startsWith('=') ? cell.substring(1) : '',
      isFormula: typeof cell === 'string' && cell.startsWith('=')
    }))
    );

    this.exportToExcel(formattedData, 'grade_sheet_template.xlsx');
  }
}